import type { IUpdateSchoolProfilePayload } from '@/types/payload';

import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getSchoolProfile = async () => {
  return serviceHelper(http.get('/school/profile'), false);
};

export const updateSchoolProfile = async (
  payload: IUpdateSchoolProfilePayload
) => {
  return serviceHelper(http.patch('/school', payload), true);
};

export const changePassword = async (payload: {
  current_password: string;
  new_password: string;
}) => {
  return serviceHelper(
    http.post('/user/change-password', { ...payload, type: 'user' }),
    true
  );
};

export const getUserSettings = async () => {
  return serviceHelper(http.get('/user/settings'), false);
};

export const updateLanguageRegion = async (
  payload: Record<string, unknown>
) => {
  return serviceHelper(http.patch('/user/settings', payload), true);
};

export const getSubscription = async () => {
  return serviceHelper(http.get('/school/billing'), false);
};

export const cancelSubscription = async () => {
  return serviceHelper(http.post('/school/subscription/cancel'), true);
};

export const requestSubscriptionRenewal = async () => {
  return serviceHelper(http.post('/school/subscription/request-renewal'), true);
};

export const getBillingHistory = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/school/billing-history?${queryString}`),
    false
  );
};

export const getDeletedRecords = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(http.get(`/school/restore?${queryString}`), false);
};

export const restoreRecord = async (id: string) => {
  return serviceHelper(http.post(`/school/restore/${id}`), true);
};

export const getTeacherProfile = async () => {
  return serviceHelper(http.get('/teacher'), false);
};

export const permanentlyDeleteRecord = async (
  id: string,
  recordType: number
) => {
  return serviceHelper(
    http.delete(
      `/school/restore/permanently-delete/${id}?record_type=${recordType}`
    ),
    true
  );
};

export const updateTeacherProfile = async (
  payload: IUpdateSchoolProfilePayload
) => {
  return serviceHelper(http.patch('/teacher', payload), true);
};

export const uploadUserProfileImage = async (formData: FormData) => {
  return serviceHelper(
    http.post('/upload/user/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    false,
    true
  );
};

export const getTeacherPreferences = async () => {
  return serviceHelper(http.get('/teacher/summary-email'), false);
};

export const updateTeacherPreferences = async (payload: {
  weekly_summary_email: boolean;
}) => {
  return serviceHelper(http.patch('/teacher/summary-email', payload), true);
};
